'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const manageState = SelectComponent => {
  var _class, _temp2;

  return _temp2 = _class = class StateManager extends _react.Component {
    constructor(...args) {
      var _temp;

      return _temp = super(...args), this.state = {
        inputValue: this.props.inputValue !== undefined ? this.props.inputValue : this.props.defaultInputValue,
        menuIsOpen: this.props.menuIsOpen !== undefined ? this.props.menuIsOpen : this.props.defaultMenuIsOpen,
        value: this.props.value !== undefined ? this.props.value : this.props.defaultValue
      }, this.onChange = (value, actionMeta) => {
        this.callProp('onChange', value, actionMeta);
        this.setState({ value });
      }, this.onInputChange = (value, actionMeta) => {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        const newValue = this.callProp('onInputChange', value, actionMeta);
        this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      }, this.onMenuOpen = () => {
        this.callProp('onMenuOpen');
        this.setState({ menuIsOpen: true });
      }, this.onMenuClose = () => {
        this.callProp('onMenuClose');
        this.setState({ menuIsOpen: false });
      }, _temp;
    }

    focus() {
      this.select.focus();
    }
    blur() {
      this.select.blur();
    }
    getProp(key) {
      return this.props[key] !== undefined ? this.props[key] : this.state[key];
    }
    callProp(name, ...args) {
      if (typeof this.props[name] === 'function') {
        return this.props[name](...args);
      }
    }

    render() {
      return _react2.default.createElement(SelectComponent, _extends({}, this.props, {
        ref: ref => {
          this.select = ref;
        },
        inputValue: this.getProp('inputValue'),
        menuIsOpen: this.getProp('menuIsOpen'),
        onChange: this.onChange,
        onInputChange: this.onInputChange,
        onMenuClose: this.onMenuClose,
        onMenuOpen: this.onMenuOpen,
        value: this.getProp('value')
      }));
    }
  }, _class.defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  }, _temp2;
};

exports.default = manageState;